export default "__VITE_ASSET__eWL74SoQ__"